import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from 'react';
import { _eval } from "../utils";
import BaseField from './BaseField';

function RadioInput(props) {

    const [showError, setShowError] = useState(false);
    const [selectedRadio, setSelectedRadio] = useState(false);

    const handleChange = (v) => {

        props.data.value = false
        setSelectedRadio(v)

        // Check if we must map the field
        const map = (() => {
            if (_eval(props, 'data', 'map'))
                return props.data.map
            else
                return false
        })()

        // If we must keep the label in the value,
        // concat the label with the value
        if (_eval(props, 'data', 'keepLabel'))
            if (props.data.keepLabel === true)
                v = props.data.label + ' -> ' + v

        // send data to parent
        props.handleChange(props.data.sid, { value: v, validity: true, map: map })

    }

    return (
        <BaseField
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        >

            <Form.Group>

                {props.data.label.length > 0 ?
                    <Form.Label htmlFor={`input-for-${props.data.sid}`}>
                        {props.data.label}
                        {props.data.required ?
                            <span className='text-danger'>&nbsp;*</span>
                            : null}
                    </Form.Label>
                    : null}

                {props.data.items.map((c, i) => {
                    const label = !_eval(c, 'label') ? c : c.label;
                    const value = !_eval(c, 'value') ? c : c.value;
                    if (c.groupLabel) {
                        return (
                            <div key={i} className='text-muted my-2'><i>— {c.groupLabel}</i></div>
                        )
                    } else {

                        return (

                            <Form.Check
                                key={i}
                                type={'radio'}
                                id={`radio-for-${props.data.sid}-key-${i}`}
                                feedback={props.data.helper}
                                feedbackType="invalid"
                            >
                                <Form.Check.Input
                                    data-validity-selector={props.data.sid}
                                    type={'radio'}
                                    checked={selectedRadio === value || props.data.value === value}
                                    onChange={e => { handleChange(value) }}
                                    disabled={c.disabled}
                                />
                                <Form.Check.Label dangerouslySetInnerHTML={{ __html: label }}>
                                </Form.Check.Label>
                            </Form.Check>
                        )
                    }
                })}

                {props.data.helper ?
                    <Form.Text id={`helper-for-${props.data.sid}`} muted dangerouslySetInnerHTML={{ __html: props.data.helper }} />
                    : null}

                {/* Field live check */}
                {props.data.error && showError ?
                    <div>
                        <Form.Text id={`error-for-${props.data.sid}`} className='text-danger'>
                            {props.data.error}
                        </Form.Text>
                    </div>
                    : null}

                {/* Field check validity on submit */}
                {!(props.data.error && showError) ?
                    <Form.Control.Feedback type="invalid">
                        {props.data.error}
                    </Form.Control.Feedback>
                    : null}

            </Form.Group>

        </BaseField>
    );
}

export default RadioInput;